import {
  Box,
  Icon,
  Inline,
  Stack,
  Typography,
} from '@omnipresentgroup/design-system';
import { toSentenceCase } from '@omnipresentgroup/helpers';
import type { Benefit } from '@omnipresentgroup/types';

import { BenefitPackageTag } from './BenefitPackageTag';

export const BenefitCell = ({ benefit }: { benefit: Benefit }) => (
  <Inline align="center">
    {benefit.package && (
      <Box css={{ width: 80 }}>
        <BenefitPackageTag benefit={benefit} fullWidth />
      </Box>
    )}
    <Stack gap="0">
      <Inline align="center" gap="4">
        <Typography as="span" size="14">
          {toSentenceCase(benefit.benefitType ?? '')}
        </Typography>
        {benefit.mandatory ? (
          <Icon icon="CircleLetterM" size="16" />
        ) : (
          <Box css={{ width: 40 }} />
        )}
      </Inline>
      {benefit.vendor && (
        <Typography as="span" color="subtle" size="12">
          {benefit.vendor}
        </Typography>
      )}
    </Stack>
  </Inline>
);
